// extracted by mini-css-extract-plugin
module.exports = {"arrow":"post-styles-module--arrow--LAlcs","pt":"post-styles-module--pt--2S-eM","date":"post-styles-module--date--3dldR"};